import { defaultWishes } from '@/data/wishes.js'
import { storage } from '@/utils/storage.js'

export default {
  namespaced: true,
  state: () => ({
    items: defaultWishes.map(w => {
      const stored = (storage.get('wishes') || {})[w.id]
      return {
        ...w,
        done: stored?.done || false,
        doneAt: stored?.doneAt || null,
      }
    }),
  }),
  getters: {
    total: s => s.items.length,
    completed: s => s.items.filter(i => i.done).length,
    progress: (s, g) => (g.total === 0 ? 0 : g.completed / g.total),
  },
  mutations: {
    toggle(state, id) {
      const item = state.items.find(i => i.id === id)
      if (!item) return
      item.done = !item.done
      item.doneAt = item.done ? new Date().toISOString() : null
      const all = storage.get('wishes') || {}
      all[id] = { done: item.done, doneAt: item.doneAt }
      storage.set('wishes', all)
    },
  },
}
